module.exports = __webpack_public_path__ + "static/media/p3.e1ee25d4.jpg";